import {useLayoutEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actionCreator, RootState} from '../_modules';
import {RectAngle} from '../schema';
import {Handlers, State, Store} from './types';
import View from './view';

const Map: React.FC = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState<State>({
    height: undefined,
    initZoom: undefined,
  });

  const store: Store = useSelector((rootState: RootState): Store => {
    return {
      activeArticleKey: rootState.activeArticleId,
      pointerFeature: rootState.pointerFeature,
      gjfs: rootState.gjfs,
      center: rootState.mapCenter,
      searchType: rootState.searchType,
      fgRef: undefined,
      activeLocation: rootState.activeLocation,
      mapBounds: rootState.mapBounds,
    };
  });

  const handlers: Handlers = {
    createRect: (event) => {
      interface LatLng {lat: number, lng: number};
      // console.log(event.layer._latlngs);
      const latlngs = event.layer._latlngs[0] as LatLng[];
      const listLng = latlngs.map((e) => e.lng);
      const listLat = latlngs.map((e) => e.lat);
      const rect: RectAngle = {
        minLngLat: [
          listLng.reduce((a, b) => a < b ? a : b, listLng[0]),
          listLat.reduce((a, b) => a < b ? a : b, listLat[0]),
        ],
        maxLngLat: [
          listLng.reduce((a, b) => a > b ? a : b, listLng[0]),
          listLat.reduce((a, b) => a > b ? a : b, listLat[0]),
        ],
      };
      dispatch(actionCreator.setRectAngle({...rect}));
    },
  };

  useLayoutEffect(() => {
    const updateSize = (): void => {
      const initZoom = window.innerWidth > 1280 ? 2 : window.innerWidth > 640 ? 1 : 0;
      setState({...state, height: 250 * 2 ** (initZoom), initZoom});
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return <View {...{store, handlers, state}}/>;
};

export default Map;
